<template>
  <div v-if="entry">
    <NavbarSite
      v-if="isSite"
      :key="$vnode.key"
    />
    <NavbarDropdown
      v-if="isDropdown"
      :key="$vnode.key"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import NavbarSite from '@/components/Nav/NavbarSite'
import NavbarDropdown from '@/components/Nav/NavbarDropdown'

export default {
  name: 'NavEntry',
  components: {
    NavbarDropdown,
    NavbarSite
  },
  data () {
    return {
      NavEntryPosition: parseInt(this.$vnode.key)
    }
  },
  computed: {
    isSite () {
      return this.entry.type !== 'dropdown'
    },
    isDropdown () {
      return this.entry.type === 'dropdown'
    },
    entry () {
      return this.getStoredNavEntryByPosition(this.NavEntryPosition)
    },
    ...mapGetters([
      'getStoredNavEntryByPosition'
    ])
  }
}
</script>

<style scoped>

</style>
